import { PaidOutlined } from '@mui/icons-material';
import { useHistory } from 'react-router';
import { useAppDispatch } from 'hooks/redux';
import { URLPaths } from 'models/enums';
import useClickApptValueAssumption from 'hooks/queries/useClickApptValueAssumption';
import Button from 'domains/core/components/Button';
import EmptyStateLayout from 'domains/core/components/EmptyStateLayout';
import PageLayout from 'domains/core/components/PageLayout';
import ErrorSnackbar from 'domains/core/components/Snackbars/ErrorSnackbar';
import ValueCalculatorTable from 'domains/value/pages/ValueCalculatorTable';
import { reset } from 'domains/value/state/value';
import { useAccessCentrePermissions } from 'hooks/useAccessCentrePermissions';

const ValueCalculatorPage = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { canCreateValue } = useAccessCentrePermissions();
    const {
        data: clickApptValueAssumption,
        error: clickApptValueAssumptionError,
        isError: isClickApptValueAssumptionError,
        isLoading: isClickApptValueAssumptionLoading,
        isRefetching: isClickApptValueAssumptionRefetching,
        isSuccess: isClickApptValueAssumptionSuccess,
        refetch: clickApptValueAssumptionRefetch,
    } = useClickApptValueAssumption();

    const onClickCreate = () => {
        history.push(URLPaths.VALUE_SEND_SPECIALTY);
        dispatch(reset());
    };

    const isEmpty = isClickApptValueAssumptionSuccess && !clickApptValueAssumption?.length;

    const createButton = canCreateValue ? (
        <Button variant="outlined" endIcon={<PaidOutlined />} onClick={onClickCreate}>
            Create
        </Button>
    ) : undefined;

    if (isEmpty) {
        return (
            <EmptyStateLayout caption="value" header="track the impact of your marketing efforts">
                {createButton}
            </EmptyStateLayout>
        );
    }

    return (
        <PageLayout header="value" headerIcon={<PaidOutlined fontSize="inherit" />} headerAction={createButton}>
            {isClickApptValueAssumptionError && <ErrorSnackbar errorMessage={clickApptValueAssumptionError?.message} />}
            {(isClickApptValueAssumptionLoading || isClickApptValueAssumptionSuccess) && (
                <ValueCalculatorTable
                    clickApptValueAssumptionResponses={clickApptValueAssumption ?? []}
                    isLoading={isClickApptValueAssumptionLoading}
                    isRefetching={isClickApptValueAssumptionRefetching}
                    refetch={clickApptValueAssumptionRefetch}
                />
            )}
        </PageLayout>
    );
};

export default ValueCalculatorPage;
